import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useBCMSModal, useGlobalController, useModel, useParams, useStateManager } from "@bcm-dev/bcms-vite";
import Classes, { Account, Transaction } from "model";
import { useEffect } from "react";
import TransactionSearch from "./classes/TransactionSearch";

import { ConfirmBannerView, LeftColumnContainer, PageContainer, PageContentView, RightColumnContainer, WidgetContainer } from 'components/shared';
import ChangeLoginWidget from "components/shared/widgets/ChangeLoginWidget";
import CreditScoreLeftColWidget from "components/shared/widgets/CreditScoreLeftColWidget";
import CreditScoreWidget from 'components/shared/widgets/CreditScoreWidget';
import QuickLinksWidget from "components/shared/widgets/QuickLinksWidget";
import { SVGAsset } from "res";
import ColumnAdWidget from "../AccountSummaryPage/components/ColumnAdWidget";
import MobileColumnAdWidget from "../AccountSummaryPage/components/MobileColumnAdWidget";
import AccountDetailsView from './components/AccountDetailsView';
import MobileTransactionsTable from './components/MobileTransactionsTable';
import TransactionSearchAccordion from './components/TransactionSearchAccordion';
import TransactionSearchCriteria from './components/TransactionSearchCriteria';
import TransactionsView from './components/TransactionsView';
import "./styles.css";


export default function AccountDetailsPage(props) {
    const bcmsContext = useBCMSContext();
    // Global controller used to cause a refresh of the page when the account details modal
    // updates the account name
    const globalContext = useGlobalController();

    BCMSRecord.globalControllerFor(Classes, bcmsContext);
    var paramsAccountID = useParams().accountID;
    let accountID = paramsAccountID;

    try {
      // Check if the params account id is valid.
      const accountExists = Account.initByType(paramsAccountID);
    } catch {
      // It's not valid here, so default to a checking account or loc account.
      accountID = Account.getDefaultBrandedAccountByType("checking").id;
    }

    const data = { ...getDefaultPageData(accountID), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };
    const className = props.className?(" "+props.className):"";

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,

        forceUpdate: (data, ui) => {
          BCMSStateManagerCRUD.init(state)
            .update([ "data" ], data)
            .update([ "ui" ], ui)
            .submit(setState);
        },

        onSearchUpdate: prop => value => {
          BCMSStateManagerCRUD.init(state)
            .update([ "data", "search", prop ], value)
            .submit(setState);
        },

        onSearchAmountUpdate: value => {
          BCMSStateManagerCRUD.init(state)
            .update([ "data", "search", "amount" ], parseFloat(value.amount) === 0 || value.amount === "" ? "" : value)
            .submit(setState);
        },

        onSearchReset: evt => {
          BCMSStateManagerCRUD.init(state)  
            .update([ "data", "search" ], data.search.reset())
            .update([ "data", "submittedSearch"], data.search.reset())
            .update([ "data", "transactions" ], Transaction.initByAccount(accountID))
            .update([ "ui", "searchByCheck" ], false)
            //.update([ "ui", "searchCriteria", "isActive" ], false)
            .update([ "ui", "searchClearSearchButton", "isActive" ], false)
            .submit(setState);
        },

        onSearchSubmit: evt => {
          BCMSStateManagerCRUD.init(state)
            .update([ "data", "transactions" ], state.data.search.filter())
            .update([ "data", "submittedSearch"], TransactionSearch.init(state.data.search.record))
            .update([ "ui", "searchAccordion", "isActive" ], false)
            //.update([ "ui", "searchCriteria", "isActive" ], true)
            .update([ "ui", "searchClearSearchButton", "isActive" ], true)
            .submit(setState);
        },

        onSearchAccordionClick: value => {
          BCMSStateManagerCRUD.init(state)
            .update([ "ui", "searchAccordion", "isActive" ], value)
            .submit(setState);
        },

        onSearchByCheck: evt => {
          BCMSStateManagerCRUD.init(state)
            .update([ "ui", "searchByCheck" ], true)
            .submit(setState);
        },

        onTransactionInquiryModalSendButtonClick: transactionID => evt => {
          BCMSStateManagerCRUD.init(state)
            .update([ "ui", "showTransactionInquirySuccessBanner" ], { show: true })
            .submit(setState);
        },

        onConfirmBannerViewCloseButtonClick: evt => {
          console.log(evt)
          BCMSStateManagerCRUD.init(state)
            .update([ "ui", "showTransactionInquirySuccessBanner" ], { show: false })
            .submit(setState);
        },

        onHasMoreClick: evt => {
          BCMSStateManagerCRUD.init(state)
            .update([ "ui", "showMoreTransactions" ], true)
            .submit(setState);
        },

        onItemClick: (key, prop, value) => {
          BCMSStateManagerCRUD.init(state)
            .update([ "ui", key, prop ], value)
            .submit(setState);
        }
    });

    const accountClassName = `account_${data.account.id}`;
  
    return (
        <PageContainer className={`account-details-page ${accountClassName}${className}`} state={ { data, ui } } controller={ controller }>
            <AccountDetailsContent state={ { data, ui } } />
        </PageContainer>
    );
}
//Account.getDefaultBrandedAccountByType("checking").id
export const getDefaultPageData = id => {
  const accountID = id ?? Account.getDefaultBrandedAccountByType("checking").id;

  return {
      //account: Account.initByType(id ?? "0"),
      account: Account.initByType(accountID),
      search: TransactionSearch.init({ accountID: accountID }),
      submittedSearch: TransactionSearch.init({ accountID: accountID }),
      transactions: Transaction.initByAccount(accountID)
      /*search: TransactionSearch.init({ accountID: id ?? "0" }),
      submittedSearch: TransactionSearch.init({ accountID: id ?? "0" }),
      transactions: Transaction.initByAccount(id ?? "0")*/
  };
};

export const getDefaultPageUI = () => ({
  accountSelect: { isActive: false },
  searchAccordion: { isActive: false },
  // Property "searchCriteria" was used to show/hide the
  // "Displaying: Transaction Type: All Transaction Types; Date Range: Last 30 Days;" text,
  // but now that text is always shown.
  searchCriteria: { isActive: true },
  searchClearSearchButton: { isActive: false },

  searchType: { isActive: false },
  searchDateRange: { isActive: false },

  searchByCheck: false,
  showMoreTransactions: false,

  modal: {
    id: undefined,
    data: {}
  },
  showTransactionInquirySuccessBanner: { show: false }
});

function AccountDetailsContent(props) {
    const state = props.state;  

    const { data, ui, forceUpdate, onConfirmBannerViewCloseButtonClick } = useStateManager();
    const { open } = useBCMSModal();

    useEffect(() => {
      if(state.data.account.id !== data.account.id) {
        forceUpdate(state.data, state.ui);
      }

      if(ui.modal.id !== undefined) {
        open(ui.modal.id, ui.modal.data);
      }
    }, [ props ]);

    const { branding } = useModel();
    const { options } = branding;
    const customClientBIDBranding = options.bid_abi22;

    const mabi23Branding = window.mabi23Branding;
    let _branding = { colors: branding.colors, options: branding.options };

    if (mabi23Branding) {
      _branding = mabi23Branding;
    }

    const optionMap = (option) => {

      const key = {
        "accountdetails_left_widget_1_abi22": mabi23Branding ? "accountdetails_widget_1_mabi23" : "accountdetails_left_widget_1_abi22",
        "accountdetails_left_widget_2_abi22": mabi23Branding ? "accountdetails_widget_2_mabi23" : "accountdetails_left_widget_2_abi22",
        "accountdetails_left_widget_3_abi22": mabi23Branding ? "accountdetails_widget_3_mabi23" : "accountdetails_left_widget_3_abi22",
        "accountdetails_right_widget_1_abi22": mabi23Branding ? "accountdetails_widget_4_mabi23" : "accountdetails_right_widget_1_abi22",
        "accountdetails_right_widget_2_abi22": mabi23Branding ? "accountdetails_widget_5_mabi23" : "accountdetails_right_widget_2_abi22",
        "accountdetails_right_widget_3_abi22": mabi23Branding ? "accountdetails_widget_6_mabi23" : "accountdetails_right_widget_3_abi22",

        "left_ad_url": mabi23Branding ? "top_ad_url_mabi23" : "left_ad_url",
        "right_top_ad_url_abi22": mabi23Branding ? "ad_1_url_mabi23" : "right_top_ad_url_abi22",
        "right_bottom_ad_url_abi22": mabi23Branding ? "ad_2_url_mabi23" : "right_bottom_ad_url_abi22"
      }

      return _branding.options[key[option]];
    }
    const colorMap = (color) => {

      const key = {
        "left_column_ad_image_abi22": mabi23Branding ? _branding.colors["top_banner_image_mabi23"] : "left_column_ad_image_abi22",
        "right_column_ad_top_image_abi22": mabi23Branding ? _branding.colors["ad_1_image_mabi23"] : "right_column_ad_top_image_abi22",
        "right_column_ad_bottom_image_abi22": mabi23Branding ? _branding.colors["ad_2_image_mabi23"] : "right_column_ad_bottom_image_abi22",

      }
      return key[color];
    }


  let ad = <div key={"ad_container"}>
    {mabi23Branding ?
      <MobileColumnAdWidget key="mobileAd" adImageURL={colorMap("left_column_ad_image_abi22")} adLinkURL={optionMap("left_ad_url")} />
      : <ColumnAdWidget key="ad" brandingColorName={colorMap("left_column_ad_image_abi22")} adURL={optionMap("left_ad_url")} />
    }
  </div>
  let ad_1 = <div key={"ad_container"}>
    {mabi23Branding ?
      <MobileColumnAdWidget key="mobileAd_1" adImageURL={colorMap("right_column_ad_top_image_abi22")} adLinkURL={optionMap("right_top_ad_url_abi22")} />
      : <ColumnAdWidget key="ad_1" brandingColorName={colorMap("right_column_ad_top_image_abi22")} adURL={optionMap("right_top_ad_url_abi22")} />
    }
  </div>
  let ad_2 = <div key={"ad_container"}>
    {mabi23Branding ?
      <MobileColumnAdWidget key="mobileAd_1" adImageURL={colorMap("right_column_ad_bottom_image_abi22")} adLinkURL={optionMap("right_bottom_ad_url_abi22")} />
      : <ColumnAdWidget key="ad_1" brandingColorName={"right_column_ad_bottom_image_abi22"} adURL={optionMap("right_bottom_ad_url_abi22")} />
    }
  </div>

// Set the left column widgets
  const mapLeftWidgets = (option) => {
    const key = optionMap(option);

    const widget = {
      "None": false,
      "Account Details":
        <WidgetContainer>
          <AccountDetailsView key={`DetailsView_${Date.now()}`} />
          <TransactionSearchAccordion />
          <TransactionSearchCriteria />
          <TransactionsView />
          <MobileTransactionsTable />
        </WidgetContainer>,
      "Ad": ad,
      "Credit Score": <CreditScoreLeftColWidget />
    }

    const Widget = () => widget[key];

    return <Widget key={option} />;
  }

  let leftWidgets = [];

  if (optionMap("accountdetails_left_widget_1_abi22"))
    leftWidgets.push(mapLeftWidgets("accountdetails_left_widget_1_abi22"));
  if (optionMap("accountdetails_left_widget_2_abi22"))
    leftWidgets.push(mapLeftWidgets("accountdetails_left_widget_2_abi22"));
  if (optionMap("accountdetails_left_widget_3_abi22"))
    leftWidgets.push(mapLeftWidgets("accountdetails_left_widget_3_abi22"));

  // Set the right column widgets
  const mapRightWidgets = (option) => {
    const key = optionMap(option);

    const widget = {
      "None": false,
      "Quick Links": <QuickLinksWidget />,
      "Credit Score": <CreditScoreWidget />,
      "Ad 1": ad_1,
      "Ad 2": ad_2,
      "Change Login": <ChangeLoginWidget/>
    }

    if(widget[key]){
      const Widget = () => widget[key];
      return <Widget key={option} />;
    }else{
      return false;
    }
  
  }
  
  let rightWidgets = [];
  
  if (optionMap("accountdetails_right_widget_1_abi22"))
    mapRightWidgets("accountdetails_right_widget_1_abi22") && rightWidgets.push(mapRightWidgets("accountdetails_right_widget_1_abi22"));
  if (optionMap("accountdetails_right_widget_2_abi22"))
    mapRightWidgets("accountdetails_right_widget_2_abi22") && rightWidgets.push(mapRightWidgets("accountdetails_right_widget_2_abi22"));
  if (optionMap("accountdetails_right_widget_3_abi22"))
    mapRightWidgets("accountdetails_right_widget_3_abi22") && rightWidgets.push(mapRightWidgets("accountdetails_right_widget_3_abi22"));

  const hasRightWidgets = rightWidgets.length > 0;

    return (
      <>
        <PageContentView>
          { ui.showTransactionInquirySuccessBanner.show &&
          <ConfirmBannerView text={ `Your message was sent successfully. Tracking ID: 12345678` }
          icon={<SVGAsset id="CircleCheckmarkIcon" className="set-width icon checkmark-icon" />}
          onClick={ onConfirmBannerViewCloseButtonClick } />
          }
          
          <LeftColumnContainer>
            {leftWidgets}
          </LeftColumnContainer>
          {hasRightWidgets &&
            <RightColumnContainer>
              {rightWidgets}
            </RightColumnContainer>
          } 
        </PageContentView>
      </>
    );
}